export default __webpack_public_path__ + "static/media/sound-wave.ba0dfba1.png";